import Vue from 'vue'
import BikeComponents from '@mt-material/bike-components-vue'
import '@mt-material/bike-components-vue/lib/theme-chalk/index.css'

Vue.use(BikeComponents)
